
import { theme } from "../../../../../../../helpers/theme";
import { Alert, Snackbar } from "@mui/material";

interface SuccessInfoProps {
    message: string;
    openSuccessInfo: boolean;
    setOpenSuccessInfo: (openSuccessInfo: boolean) => void;
}


export const SuccessMessage = (props: SuccessInfoProps) => {
    const { message, openSuccessInfo, setOpenSuccessInfo } = props;

    const handleClick = () => {
        setOpenSuccessInfo(true);
    };
    const handleClose = () => {
        setOpenSuccessInfo(false);
    };
    return (
        <Snackbar
            open={openSuccessInfo}
            autoHideDuration={6000}
            onClose={handleClose}
            sx={{
                position: "static",
                display: "felx",
                alignItems: "flex-start",

            }}
        >
            <Alert
                onClose={handleClose}
                severity="success"
                sx={{
                    marginTop: "16px",
                    width: '100%',
                    fontFamily: `${theme.fonts.interRegular}`,
                    fontSize: "14px",
                    backgroundColor: `${theme.colors.green02_disabled}`,
                    '& .MuiAlert-message': {
                        color: `${theme.colors.black_primaryText}`
                    }
                }
                } >
                {message}
            </Alert >
        </Snackbar >

    );
}